export const AVAILABLE = "Available"
export const CONNECTING = "Connecting..."
export const RECONNECTING = "Reconnecting..."
export const RELOAD_REQUIRED = "Reload Required"
export const ANA = "Agent Not Answering"
export const ACD_ASSIGNED = "ACD Assigned"
export const BUSY = "Busy"
export const OFF_QUEUE = "Off Queue"
export const ON_BREAK = "On Break"
export const OFFLINE = "Offline"
export const IN_QA_MEETING = "In a QA Meeting"
export const FOLLOW_UP = "Follow-up"
export const FOLLOW_UP_EXTENDED = "Follow-up Extended"
export const NOT_READY = "Not Ready"
export const AT_LUNCH = "At Lunch"
export const COACHING = "Coaching"
export const AT_A_TRAINING_SESSION = "At a Training Session"
export const CALL_BACK = "Call back"
export const TEAM_MEETING = "Team Meeting"
export const SYSTEM_ISSUES = "System Issues"

/** Individual presence statuses supported by the Available Agents status filter */
export const agentFilterPresences = [
  NOT_READY,
  AVAILABLE,
  ON_BREAK,
  AT_LUNCH,
  COACHING,
  AT_A_TRAINING_SESSION,
  IN_QA_MEETING,
  TEAM_MEETING,
  SYSTEM_ISSUES,
  CALL_BACK,
  OFFLINE,
  ACD_ASSIGNED,
  ANA,
  BUSY,
  FOLLOW_UP,
  FOLLOW_UP_EXTENDED,
]
